export const CHANGE_NEW_REQUESTS = 'CHANGE_NEW_REQUESTS'
export const CHANGE_REQUESTS_FILTER = 'CHANGE_REQUESTS_FILTER'
export const CHANGE_MODELS_FILTER = 'CHANGE_MODELS_FILTER'
export const CHANGE_CLIENT_ARTICLES = 'CHANGE_CLIENT_ARTICLES'
export const SET_CLIENT_MALEMODELS = 'SET_CLIENT_MALEMODELS'
export const SET_CLIENT_FEMALEMODELS = 'SET_CLIENT_FEMALEMODELS'
export const SET_ALGOLIA_CLIENT = 'SET_ALGOLIA_CLIENT'